module.exports = __webpack_public_path__ + "static/media/izlozba (19).0a7ce79e.jpg";